import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AdminPageHeader } from '@/components/admin/AdminPageHeader';

export const Route = createFileRoute('/admin/agent')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/admin/agent' || location.pathname === '/admin/agent/') {
      throw redirect({ to: '/admin/agent/concerns' });
    }
  },
  component: AgentLayout,
});

function AgentLayout() {
  return (
    <div className="space-y-6">
      <AdminPageHeader
        eyebrow="Reviewer console"
        title="Agent"
        description="What the NightAI assistant is doing across every return — open concerns, prefill health, and conversation activity. Switch views from the sidebar."
      />
      <Outlet />
    </div>
  );
}
